import type { Scopes } from '@atlassian/post-office-context';

/**
 * Scopes configuration for the rovo-nudge placement.
 *
 * Each scope defines a named context (product + route) that the placement
 * should be active for. When the user navigates to a matching route,
 * the scope becomes active and is passed to the subscription query
 * so that the server can filter messages accordingly.
 *
 * Add or modify scopes here as new rovo-nudge use cases are introduced.
 */
export const scopes: Scopes = [
	{
		name: 'jira/backlog',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					// Jira uses both `/jira/software/c/projects/...` (classic) and
					// `/jira/software/projects/...` (no `c`) — same as screen-space-flags.
					matches: '/jira/software(?:/c)?/projects/.*/boards/.*/backlog',
				},
			},
		},
	},
	{
		name: 'jira/board',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: '/jira/software(?:/c)?/projects/.*/boards/[^/]+$',
				},
			},
		},
	},
];
